import request from '@/util/request'

export function getList(data,Modu,Type) {
  return request({
    url: '?Modu='+ Modu +'&Type=' + Type,
    method: 'post',
    data
  })
}
